const HYPHEN_SEPARATOR = '-';

/**
 * Converts given date string to ISO format 'yyyy-mm-dd'
 * splitter is any non word character
 *
 * Valid input date examples: 'dd.mm.yyyy', 'dd/mm/yyyy'
 * Invalid input date examples: 'dd.mm.yy', 'ddmmyyyy'
 */
export function toISO(date: string): string {
    const parts = date !== ''
        ? date.split(/\W/g)
        : [];

    return isValid(parts, 2) ? parts.reverse().join(HYPHEN_SEPARATOR) : date;
}

/**
 * Reverses ISO date string and joins with new separator (yyyy-mm-dd to dd.mm.yyyy)
 * Valid date example: 'yyyy-mm-dd'
 * Invalid date example: 'yy-mm-dd'
 *
 * newSeparator: separator with which input string will be joined, example: '.'
 */
export function fromISO(date: string, newSeparator: string): string {
    const parts = date !== '' && date.indexOf(HYPHEN_SEPARATOR) > 0
        ? date.split(HYPHEN_SEPARATOR)
        : [];

    return isValid(parts, 0) ? parts.reverse().join(newSeparator.trim()) : date;
}

function isValid (parts: string[], idx: number): boolean {
    return parts.length === 3 && parts[idx].length === 4;
}
